import ErrorIcon from "vue-material-design-icons/AlertCircle";
import InfoIcon from "vue-material-design-icons/Information";
import SuccessIcon from "vue-material-design-icons/CheckCircle";
import { TYPE } from "vue-toastification";
import i18n from "../i18n";

export const DAY = "1d";
export const FIVE_DAYS = "5d";
export const MONTH = "m";
export const DEFAULT = "default";

export const SUCCESS = "SUCCESS";

export const ICONS_FILL_COLOR = "#043E96";
export const LIGHT_GREEN = "#9FD6D4";
export const LIGHT_RED = "#ffb4bc";
export const LIGHT_ORANGE = "#FBDAD1";
export const LIGHT_PURPLE = "#D5D1FE";
export const DARK_GREEN = "#298C89";
export const DARK_RED = "#C84654";
export const PRIMARY_FONT_BLUE = "#3687FF";

export const CSV_FILE = "text/csv";
export const EXCEL_FILE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const WEIGHT = "weight";
export const CAPITAL = "capital";
export const AMOUNT = "amount";

export const RESERVE_TICKER = "SHV";

export const PORTFOLIO = "portfolio";
export const POOL = "pool";
export const RENAME_PORTFOLIO = "rename";
export const CASH_RESERVE_USD = 1;
export const CASH_RESERVE_PERCENT = 2;

// report privileges

/* Global settings for alerts */
export const GLOBAL_TOAST_OPTIONS = {
  position: "bottom-left",
  icon: false,
  hideProgressBar: true,
  toastDefaults: {
    [TYPE.SUCCESS]: {
      timeout: 4000,
      icon: SuccessIcon
    },
    [TYPE.ERROR]: {
      timeout: 4000,
      icon: ErrorIcon
    },
    [TYPE.INFO]: {
      timeout: 6000,
      icon: InfoIcon
    }
  }
};

export const DELETE_ACC_OPTIONS = [
  {
    id: 0,
    name: "temporaryAcc"
  },
  {
    id: 1,
    name: "noLongerInterested"
  },
  {
    id: 2,
    name: "alternative"
  },
  {
    id: 3,
    name: "price"
  },
  {
    id: 4,
    name: "needs"
  },
  {
    id: 5,
    name: "service"
  },
  {
    id: 6,
    name: "other"
  }
];

export const PASSWORD_REGEX = /^(?=.*)(?=.*\d).{8,}$/;

export const DATE_TIME_FORMAT = () =>
  i18n.locale === "cs" ? "DD. MM. YYYY" : "DD MMM YYYY";

export const POOL_OPTIONS = () => [
  {
    name: i18n.t("portfolioManager.poolOptions.sp100"),
    value: "S&P100"
  }
];

export const VALUE_OPTIONS = () => [
  {
    name: i18n.t("portfolioManager.poolSidebar.weights"),
    value: WEIGHT
  },
  {
    name: i18n.t("portfolioManager.poolSidebar.capital"),
    value: CAPITAL
  },
  {
    name: i18n.t("portfolioManager.poolSidebar.wholeStocks"),
    value: AMOUNT
  }
];

export const RULE_OPTIONS = () => [
  {
    name: i18n.t("portfolioManager.ruleOptions.weight"),
    value: "weight"
  },
  {
    name: i18n.t("portfolioManager.ruleOptions.count"),
    value: "count"
  },
  {
    name: i18n.t("portfolioManager.ruleOptions.tickers"),
    value: "tickers"
  }
];

export const OBJECTIVE_OPTIONS = () => [
  {
    name: i18n.t("portfolioManager.suggestOptimalization.minVolatility"),
    value: MIN_VOLATILITY
  },
  {
    name: i18n.t("portfolioManager.suggestOptimalization.maxSharpe"),
    value: MAX_SHARPE
  },
  {
    name: i18n.t("portfolioManager.suggestOptimalization.maxReturn"),
    value: MAX_RETURN
  }
];

export const MIN = "min";
export const MAX = "max";

export const LIMIT_OPTIONS = () => [
  {
    name: "MIN",
    value: MIN
  },
  {
    name: "MAX",
    value: MAX
  }
];

export const RESAMPLING_FREQUENCY_OPTIONS = () => [
  {
    name: i18n.t("general.daily"),
    value: "Daily"
  },
  {
    name: i18n.t("general.monthly"),
    value: "Monthly"
  }
];

export const ALL_PRODUCTS = {
  patternLab: "Pattern_lab",
  portfolioOptimization: "Portfolio_optimization",
  portfolioManager: "Pattern_lab",
  tax: "Tax_app",
  factorInvesting: "Factor_investing_basic",
  marketSentiment: "SFA_articles",
  stockPickingLab: "Stockpicker",
  stockRanking: "IBKR_rebalance"
};

export const pathPermissions = {
  "/portfolioManager":  ALL_PRODUCTS.portfolioOptimization,
  "/stockPickingLab": ALL_PRODUCTS.stockPickingLab,
  "/taxes": ALL_PRODUCTS.tax,
  "/marketSentiment": ALL_PRODUCTS.marketSentiment,
  "/stockRanking": ALL_PRODUCTS.stockRanking,
  "/patternLab": ALL_PRODUCTS.patternLab
};


export const CUSTOM_PORTFOLIO = "custom_portfolio";
export const MAX_SHARPE = "max_sharpe";
export const MIN_VOLATILITY = "min_volatility";
export const MAX_RETURN = "max_return";
export const REPLACEMENT_MAX_SHARPE = "replacement_max_sharpe";
export const REPLACEMENT_MIN_VOLATILITY = "replacement_min_volatility";

export const REPLACEMENT_PORTFOLIOS = [
  REPLACEMENT_MAX_SHARPE,
  REPLACEMENT_MIN_VOLATILITY
];
export const WEIGHT_CHART_COLORS = [
  "#002D62",
  "#007FFF",
  "#89CFF0",
  "#0066b2",
  "#00308F",
  "#72A0C1",
  "#F0F8FF",
  "#00FFFF",
  "#7FFFD4",
  "#6CB4EE",
  "#0000FF",
  "#318CE7",
  "#5072A7",
  "#6699CC",
  "#0039a6",
  "#13274F",
  "#0a2351",
  "#002244",
  "#3457D5",
  "#5F9EA0",
  "#A3C1AD",
  "#00BFFF",
  "#4B9CD3",
  "#B2FFFF",
  "#2a52be",
  "#034694",
  "#0CAFFF",
  "#0047AB",
  "#002244",
  "#B9D9EB",
  "#6495ED",
  "#1F75FE",
  "#0E3386",
  "#00FFFF",
  "#041E42",
  "#00008B",
  "#00CED1",
  "#00BFFF",
  "#1F305E",
  "#0076CE",
  "#1560bd",
  "#1E90FF",
  "#005A9C",
  "#008E97",
  "#007791",
  "#012169",
  "#1034A6",
  "#7DF9FF",
  "#6F00FF",
  "#003399",
  "#1877F2",
  "#15f4ee",
  "#2c3968",
  "#073980",
  "#6082B6",
  "#5D76A9",
  "#0530ad",
  "#99FFFF",
  "#4C516D",
  "#3F00FF",
  "#00416A",
  "#0071c5",
  "#002fa7",
  "#5A4FCF",
  "#004687",
  "#545AA7",
  "#ADD8E6",
  "#E0FFFF",
  "#87CEFA",
  "#B0C4DE",
  "#004792",
  "#0077c0",
  "#6050DC",
  "#E1EBEE",
  "#00538C",
  "#73C2FB",
  "#0000CD",
  "#7B68EE",
  "#48D1CC",
  "#002D72",
  "#191970",
  "#002244",
  "#8DA399",
  "#0093AF",
  "#000080",
  "#4D4DFF",
  "#A4DDED",
  "#002147",
  "#1ca9c9",
  "#AFEEEE",
  "#0018A8",
  "#002244",
  "#005f69",
  "#011F5B",
  "#CCCCFF",
  "#1C39BB",
  "#000f89",
  "#2E2787",
  "#224C98",
  "#00428c",
  "#B0E0E6",
  "#003153",
  "#004170",
  "#002387",
  "#00CCCC",
  "#5D8AA8",
  "#4169E1",
  "#76ABDF",
  "#082567",
  "#4B61D1",
  "#87CEEB",
  "#6A5ACD",
  "#1E2952",
  "#0070BB",
  "#4682B4",
  "#008080",
  "#367588",
  "#81D8D0",
  "#132257",
  "#2D68C4",
  "#3E8EDE",
  "#40E0D0",
  "#1da1f2",
  "#2774AE",
  "#120A8F",
  "#AFDBF5",
  "#324AB2",
  "#1a1f71",
  "#00CCFF",
  "#1D428A",
  "#00356B",
  "#0C2340",
  "#2E5090",
  "#7CB9E8"
];

export const MARKPOINT_SYMBOL =
  "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEfSURBVHgBnVK9TsJgFD33M9GYOBSmsunu4OKocfYBXGnlAWSqbsKmTLwAtqw+hdEH0MEHcFMX6GBiICGX73ykBAqhDWdo0ttzen/OEeTQjNXbneACghNXUHyMd/DSDSVd5Mniy22sN5bY8ivwatVZ7XsA/AzxpYKkE0p7RWhFse8hOD8GDvaXp/j7B14/7Q8GSB4bErJm+Ihivafo8nRVRLDGb34VQdTTpuvInfYU71dnOFwnynd+fkM6EhwZHsLuVCjKOnN/agyvlx2iDBzXagy2hKFPPHlZOK7VGJprfUq5eBHIoafUGCZCFW36VARyRNGnZh6A6EmTWgX1TQH4HaL/cC0Ba0uRu+tpy0arTntykXNTdRrSzbiSH6dsyKec6HWTZUJ3vgAAAABJRU5ErkJggg==";

export const LIFECYCLE_ICONS = {
  initialPortfolio:
    "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE4SURBVHgBjZIxLwRREMdn3p5okBUN1SkkNGgVwkoUaDTU1zubPV+EXRuiPSUa1SmEtXwBNCRXoNJINqFwZ9+ON3t3m5e42/g3+9+Z/WVmdgZBU2HetwANh5AsBDQJKELCAEh68Z0ddL7DDFg43FOPCvSWG4dbOxnUAcyBfrA3Z6C0MgnF0UF4ff+E6sUz+KcPEH01MhDTloRxzcCltw6zEyN/StzXP2DZOW+BiVwSZPQ5nOAK3QAWx+2N6daLKFQEkrTYc0t5Kq1OtR0tCjWWyZZnyJOWNxVEETseOk9aPhKERsCuWnvKhY6zPN4IlD8eW//sMf1L3cTxfZVPlcSukbzVXkRxbfi7KedOrurQaMYwPjYEvAJuiXdU3g3beyIvvt0+0i7iwFWlnd4NKiAspxeDevi/t/cL1KyHl9gt9QkAAAAASUVORK5CYII=",
  weeklyChange:
    "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACzSURBVHgBlZJBDoIwEEXnT3WPJ+AaLIziVm+iMeBJhJh4E42uROJFuAF7acdSo2Gjad+mTdOXmcx80IDR9JASVCaQFIRISFoIKhJddo9t9fmHrzA77u2R02+Krl7v+ovyFHoSjleRaU5XuJZY3cgXoxcsapxRCDzKGaJTCkLmbGcRURiRlaSlMFoWqIqCwJ2hn2WQY7qC35sWT1FcMtxyTXO+cLyc2NLJX6HeuABg+OybvRcxGUwpkPx5qgAAAABJRU5ErkJggg==",
  rebalancedPortfolio:
    "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEzSURBVHgBtVTBTcNAEJxD2OZ5JTgdBAn7bTqghHQA37ziTzA/6IBSoACkpAMowV+MlMV7uUSOc+e7i5ORLFu+3Z0d73iBAGQVze4qKkJyrkOCBbAQ28eJb86Vb2D2Qo/tLeUrX1Lpmyd8gqYVpTHwoQkYdfOLyboUtSvXS0EisOgUZ8joRr1zwqlAd/9tOtsA919z8TmU71SQAO+wd+dUMUjAtiSgGCAo8md6wKkEPh22Qa/TkmQwQV5Rf7A2pHGEJ1j5DeDBRsCqPbR21kPdALfrufjpHxgVsC0DijNkYvmcRwqGbOmCybZHCvQfexJMpjggYFvCb7A2giJbqhrdd1uw1eIEqzEEGgd7aq+gLb7blmMhu7ZVCsYM1oK9bZUCvS3PCRnpHSZU9xvMcAE0f3j7Bz2HUHuQAEzIAAAAAElFTkSuQmCC"
};
